module.exports = __webpack_public_path__ + "img/cyc.394667ea.png";